import gql from "graphql-tag";

export const CHECKOUT_MUTATION = gql`
  mutation checkoutMutation($inputData: CheckoutInput!) {
    checkout(input: $inputData) {
      clientMutationId
      order {
        id
        paymentMethod
        orderKey
        databaseId
      }
      customer {
        jwtAuthToken
        jwtRefreshToken
        id
        firstName
        lastName
        databaseId
      }
      redirect
      result
    }
  }
`;
